// Версия сборки мелко в углу (README «Каркас экрана»; FR-042б): внизу меню, у свёрнутого меню —
// только короткий коммит (полная версия — в подписи), до 900 px — в углу листа.
import { cx } from '@kp/ui';
import { useMe } from './session.ts';

export function BuildVersion({
  compact = false,
  className,
}: {
  /** Свёрнутое меню: в колонке иконок виден только короткий коммит. */
  compact?: boolean;
  className?: string;
}) {
  const { build } = useMe();
  return (
    <p
      className={cx('kp-build', compact && 'is-compact', className)}
      title={`Версия ${build.version}, коммит ${build.commit}`}
    >
      {compact ? <span className="kp-sr-only">{build.version} · </span> : `${build.version} · `}
      <span className="kp-code">{build.commit}</span>
    </p>
  );
}
